import {
  HTTP_METHOD_DEEP_LINK,
  HTTP_METHOD_GET,
} from '@/common/utils/request.const'

/**
 * Convert HTTP method based on the input method
 * if method is 'deeplink', return 'get'
 * @param {string} method - The input HTTP method
 * @returns {string} - The converted HTTP method
 */
export const convertHttpMethod = (method = '') => {
  if (method === HTTP_METHOD_DEEP_LINK) {
    return HTTP_METHOD_GET
  }

  return method
}
